import React from 'react';
import { Download, Printer, Shuffle } from 'lucide-react';
const auditEvents = [{
  id: '1',
  date: '1/15/2026',
  time: '3:45 PM',
  decision: 'Approved',
  creditLimit: '$100,000',
  paymentTerms: 'Net 30',
  reasoning: 'Strong financials and excellent payment history',
  eventType: 'Credit Decision',
  user: 'Sarah Chen'
}, {
  id: '2',
  date: '1/10/2026',
  time: '2:30 PM',
  decision: '--',
  creditLimit: '--',
  paymentTerms: '--',
  reasoning: '--',
  eventType: 'Recommendation Generated',
  user: 'System Note'
}, {
  id: '3',
  date: '1/10/2026',
  time: '11:45 AM',
  decision: '--',
  creditLimit: '--',
  paymentTerms: '--',
  reasoning: '--',
  eventType: 'Application Matched to Report',
  user: 'System Note'
}, {
  id: '4',
  date: '1/10/2026',
  time: '9:30 AM',
  decision: '--',
  creditLimit: '--',
  paymentTerms: '--',
  reasoning: '--',
  eventType: 'Application Submitted',
  user: 'Charlie Bucket'
}];
export function WonkaAuditLogTab() {
  return <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-3370" data-mp="1rxgyze7tstj4">
      {/* Header */}
      <div className="p-6 border-b border-gray-200" data-id="element-3371" data-mp="1vzc3erl1zn14">
        <div className="flex items-center justify-between mb-4" data-id="element-3372" data-mp="1vzvi7zfepvax">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-3373" data-mp="20x43i8vuqfge">
            Credit Decision Audit Log
          </h2>
          <div className="flex items-center gap-3" data-id="element-3374" data-mp="1497imrtdsxzd">
            <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-3375" data-mp="189hs4egdu6iz">
              <Download className="w-5 h-5 text-gray-600" data-id="element-3376" data-mp="187587vr2dm3a" />
            </button>
            <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-3377" data-mp="1d79tdz2x34zu">
              <Printer className="w-5 h-5 text-gray-600" data-id="element-3378" data-mp="1i0vuqv3mrmgc" />
            </button>
            <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-3379" data-mp="kivtfds9pyln">
              <Shuffle className="w-5 h-5 text-gray-600" data-id="element-3380" data-mp="pii3jecsuyq8" />
            </button>
          </div>
        </div>
        <div className="flex items-center justify-between" data-id="element-3381" data-mp="1st4c3vck5tmb">
          <div className="flex items-center gap-4" data-id="element-3382" data-mp="1srkxe96jvqmn">
            <select className="px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 bg-white" data-id="element-3383" data-mp="1nu1ir85xxbu6">
              <option data-id="element-3384" data-mp="21lptp84gdu9k">Filter by Event Type</option>
              <option data-id="element-3385" data-mp="1xkw6kgyu4jhq">Application Submitted</option>
              <option data-id="element-3386" data-mp="1xl5wy5nsksny">Application Matched to Report</option>
              <option data-id="element-3387" data-mp="19ujpoglm3cf0">Recommendation Generated</option>
              <option data-id="element-3388" data-mp="19x5wge0ohnw6">Credit Decision</option>
            </select>
            <select className="px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 bg-white" data-id="element-3389" data-mp="14xa3raxflivx">
              <option data-id="element-3390" data-mp="1ixb48p9saoav">Filter by User</option>
              <option data-id="element-3391" data-mp="1dwn3hbvr6t3g">Sarah Chen</option>
              <option data-id="element-3392" data-mp="1dvltzbudyenu">Charlie Bucket</option>
              <option data-id="element-3393" data-mp="1dyzsua3uc5qj">System Note</option>
            </select>
          </div>
          <div className="flex items-center gap-2" data-id="element-3394" data-mp="2u925qoczmjom">
            <span className="text-sm text-gray-600" data-id="element-3395" data-mp="2pcbqu4cx5u4s">Date Range</span>
            <input type="text" placeholder="MM/DD/YYYY – MM/DD/YYYY" className="px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 w-64" data-id="element-3396" data-mp="2pe6a7e8jle6r" />
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto" data-id="element-3397" data-mp="2nw7qd3te328l">
        <table className="w-full text-left border-collapse" data-id="element-3398" data-mp="2stq211ysjvka">
          <thead data-id="element-3399" data-mp="2stzrmofxc0pg">
            <tr className="bg-gray-50 border-b border-gray-200" data-id="element-3400" data-mp="2svkmkf65hlnu">
              <th className="px-6 py-3 text-sm font-semibold text-gray-600 whitespace-nowrap" data-id="element-3401" data-mp="3gkn0bbxnyud2">
                Date
              </th>
              <th className="px-6 py-3 text-sm font-semibold text-gray-600 whitespace-nowrap" data-id="element-3402" data-mp="3lk81zu47xgth">
                Decision
              </th>
              <th className="px-6 py-3 text-sm font-semibold text-gray-600 whitespace-nowrap" data-id="element-3403" data-mp="3brtxwupo3y45">
                Credit Limit
              </th>
              <th className="px-6 py-3 text-sm font-semibold text-gray-600 whitespace-nowrap" data-id="element-3404" data-mp="3bh9lrzehems">
                Payment Terms
              </th>
              <th className="px-6 py-3 text-sm font-semibold text-gray-600 whitespace-nowrap" data-id="element-3405" data-mp="2fnlf18osk7yx">
                Reasoning
              </th>
              <th className="px-6 py-3 text-sm font-semibold text-gray-600 whitespace-nowrap" data-id="element-3406" data-mp="2bjx72ow8zad5">
                Event Type
              </th>
              <th className="px-6 py-3 text-sm font-semibold text-gray-600 whitespace-nowrap" data-id="element-3407" data-mp="21nao65nhetdr">
                User
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-3408" data-mp="2za9l8hi363c6">
            {auditEvents.map(event => <tr key={event.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-3409" data-mp="2ucrlnhpyl0gu">
                <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap" data-id="element-3410" data-mp="2km6iri3959s4">
                  {event.date}
                </td>
                <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap" data-id="element-3411" data-mp="3i2lxpx2gel01">
                  {event.decision}
                </td>
                <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap" data-id="element-3412" data-mp="3d8r7sbw999si">
                  {event.creditLimit}
                </td>
                <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap" data-id="element-3413" data-mp="3pkjtkyrppxks">
                  {event.paymentTerms}
                </td>
                <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap" data-id="element-3414" data-mp="3uiv2n7a6o41y">
                  {event.reasoning}
                </td>
                <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap" data-id="element-3415" data-mp="7fqayrnl1alb">
                  {event.eventType}
                </td>
                <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap" data-id="element-3416" data-mp="cd8n0qwwc5xj">
                  {event.user}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}